interface Props {
  grid: boolean;
  onClick: () => void;
}

const SvgCloseAppointment: React.FC<Props> = ({ grid, onClick }) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor: "pointer" }}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3073 3.11695C15.1588 3.12046 15.0177 3.1826 14.9148 3.2898L9.49997 8.70459L4.08517 3.2898C4.03274 3.2358 3.97001 3.19288 3.90069 3.16357C3.83137 3.13425 3.75687 3.11915 3.68161 3.11915C3.56966 3.11917 3.46027 3.1526 3.36743 3.21515C3.27458 3.27769 3.20251 3.36652 3.16044 3.47025C3.11836 3.57399 3.10819 3.68792 3.13123 3.79747C3.15427 3.90702 3.20946 4.00721 3.28976 4.08521L8.70456 9.5L3.28976 14.9148C3.23578 14.9666 3.19268 15.0287 3.16299 15.0974C3.1333 15.1661 3.11761 15.24 3.11685 15.3149C3.11609 15.3897 3.13027 15.4639 3.15856 15.5332C3.18684 15.6025 3.22867 15.6655 3.28159 15.7184C3.33451 15.7713 3.39745 15.8131 3.46674 15.8414C3.53603 15.8697 3.61026 15.8839 3.6851 15.8831C3.75993 15.8824 3.83386 15.8667 3.90256 15.837C3.97126 15.8073 4.03334 15.7642 4.08517 15.7102L9.49997 10.2954L14.9148 15.7102C14.9666 15.7642 15.0287 15.8073 15.0974 15.837C15.1661 15.8667 15.24 15.8824 15.3148 15.8831C15.3897 15.8839 15.4639 15.8697 15.5332 15.8414C15.6025 15.8131 15.6654 15.7713 15.7183 15.7184C15.7713 15.6655 15.8131 15.6025 15.8414 15.5332C15.8697 15.4639 15.8838 15.3897 15.8831 15.3149C15.8823 15.24 15.8666 15.1661 15.8369 15.0974C15.8073 15.0287 15.7642 14.9666 15.7102 14.9148L10.2954 9.5L15.7102 4.08521C15.792 4.0067 15.8481 3.90531 15.8713 3.79432C15.8945 3.68334 15.8836 3.56794 15.84 3.46326C15.7965 3.35858 15.7223 3.2695 15.6273 3.2077C15.5322 3.1459 15.4207 3.11427 15.3073 3.11695Z"
        className={`${grid ? "fill-gray2" : "fill-primary"}`}
      />
    </svg>
  );
};

export default SvgCloseAppointment;
